import * as Styled from 'approot/shared/feedback/feedback.style';
import { Box } from 'approot/shared/design-system/box/box.style';
import { INTERCOM_LAUNCH_TARGET_CLASS } from 'lib/intercom/intercom';
import Text from 'approot/shared/styles/typography/text';

type Props = {
  disclaimerText: string;
  linkText?: string;
};

const ContactSupportWithDisclaimer = ({ disclaimerText, linkText }: Props) => {
  return (
    <Box $flexDirection="row" $gap={4} $justifyContent="flex-start">
      <Text $align="left" $colour="grey" $fontSize={14}>
        {disclaimerText}
        <Styled.FeedbackLink
          type="button"
          $fontWeight="medium"
          aria-haspopup="dialog"
          className={INTERCOM_LAUNCH_TARGET_CLASS}
        >
          {linkText || 'Chat with our Support Team'}
        </Styled.FeedbackLink>
      </Text>
    </Box>
  );
};

export default ContactSupportWithDisclaimer;
